<div class="container">
  <div class="row">
    <div class="col-lg-12 text-center">
      <div class="pagenot-found-sec">
        <div class="pagenot-found-row">

          <!-- RESTRICTED IMAGE SECTION -->
          <div class="restricted-img mb-4">
            <img src="assets/images/restricted.png" alt="Restricted Access" class="img-fluid" style="max-width:250px;">
          </div>

          <div class="not-found-txt">
            <h2 class="text-danger mb-3">Access Restricted</h2>
            <p>You are not authorised to access this page!</p>
            <span>
              You do not have permission for this action.  
              Please contact the admin if you believe this is a mistake.
            </span>

            <br /><br />

            <button
              type="button"
              class="btn-cmn btn-green btn-shadow text-center back-btn"
              (click)="gotoDashboard()"
            >
              Back to Dashboard
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
